import styled from "@emotion/styled";
import { Alert } from "@mui/material";

interface UploadStatusTextProps {
	error: string | undefined;
}

export const UploadModalWrapper = styled.div(({ theme }) => ({
	width: "600px",
	background: theme.project.colors.backgroundColors.main,
	padding: "16px 24px 24px",
	color: theme.project.colors.fontColors.main,
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translateY(-50%) translateX(-50%)",
	h6: {
		margin: 0
	},
	[theme.breakpoints.down("md")]: {
		maxWidth: "600px",
		width: "75%"
	}
}));

export const UploadModalHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	marginBottom: "16px",
	button: {
		backgroundColor: "transparent",
		border: "none",
		color: theme.project.colors.fontColors.main
	}
}));

export const UploadModalSubheader = styled.p(({ theme }) => ({
	...theme.project.typography.body.body1
}));

export const UploadStatusText = styled.p<UploadStatusTextProps>(({ error }) => ({
	color: error ? "var(--red-700)" : "var(--cwg-blue-900)"
}));

export const UploadAttachmentView = styled.div({
	marginBottom: ".5rem"
});

export const MaxFilesAlert = styled(Alert)({
	fontFamily: "canada-type-gibson",
	fontWeight: "var(--font-weight-medium)",
	color: "var(--red-700)",
	position: "relative",
	p: {
		margin: "0 2.75rem 0 0"
	},
	span: {
		position: "absolute",
		top: ".875rem",
		right: "1.25rem",
		padding: 0,
		cursor: "pointer",
		color: "var(--red-700)",
		background: "none",
		border: "none"
	}
});

export const DragFilesHereText = styled.p(({ theme }) => ({
	[theme.breakpoints.down("lg")]: {
		display: "none"
	}
}));

export const ModalFileDetails = styled.div({
	display: "flex",
	flexDirection: "column"
});

export const ModalLoaderBody = styled.div({
	flex: 1,
	padding: "0 1rem"
});

export const ModalFileValidation = styled.div({
	display: "flex",
	alignItems: "center",
	gap: "0.5rem"
});

export const ModalFileValidationIcon = styled.span({
	display: "flex",
	alignItems: "center"
});
